// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const balloon = "Balloon__balloon__wW0hk";
export const leftArrow = "Balloon__leftArrow__hkM8y";
export const rightArrow = "Balloon__rightArrow__6D9w8";
export const downArrow = "Balloon__downArrow__i1EqI";
export const upArrow = "Balloon__upArrow__jrrJF";
export const balloonInner = "Balloon__balloonInner__Azr9F";
export const centered = "Balloon__centered__+GYUx";
export const valueExplanation = "Balloon__valueExplanation__q1TqP";
export const value = "Balloon__value__JGtGZ";
export const edmundsLogo = "Balloon__edmundsLogo__pWwk3";
export const zillowLogo = "Balloon__zillowLogo__N7tK4";
export const link = "Balloon__link__dOCtE";